import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _wrapNativeSuper from "@babel/runtime-corejs2/helpers/esm/wrapNativeSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
export var HTTPError = /*#__PURE__*/function (_Error) {
  _inherits(HTTPError, _Error);

  var _super = _createSuper(HTTPError);

  function HTTPError(response) {
    var _this;

    _classCallCheck(this, HTTPError);

    _this = _super.call(this, "HTTP error status: ".concat(response.status));

    _defineProperty(_assertThisInitialized(_this), "response", void 0);

    _defineProperty(_assertThisInitialized(_this), "status", void 0);

    _this.name = 'HTTPError';
    _this.response = response;
    _this.status = response.status;
    return _this;
  }

  return HTTPError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWJzL2h0dHAtZXJyb3IudHMiXSwibmFtZXMiOlsiSFRUUEVycm9yIiwicmVzcG9uc2UiLCJzdGF0dXMiLCJuYW1lIiwiRXJyb3IiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLFdBQWFBLFNBQWI7QUFBQTs7QUFBQTs7QUFJRSxxQkFBWUMsUUFBWixFQUFnQztBQUFBOztBQUFBOztBQUM5QiwyREFBNEJBLFFBQVEsQ0FBQ0MsTUFBckM7O0FBRDhCOztBQUFBOztBQUc5QixVQUFLQyxJQUFMLEdBQVksV0FBWjtBQUNBLFVBQUtGLFFBQUwsR0FBZ0JBLFFBQWhCO0FBQ0EsVUFBS0MsTUFBTCxHQUFjRCxRQUFRLENBQUNDLE1BQXZCO0FBTDhCO0FBTS9COztBQVZIO0FBQUEsaUNBQStCRSxLQUEvQiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjbGFzcyBIVFRQRXJyb3IgZXh0ZW5kcyBFcnJvciB7XG4gIHB1YmxpYyByZXNwb25zZTogUmVzcG9uc2U7XG4gIHB1YmxpYyBzdGF0dXM6IG51bWJlcjtcblxuICBjb25zdHJ1Y3RvcihyZXNwb25zZTogUmVzcG9uc2UpIHtcbiAgICBzdXBlcihgSFRUUCBlcnJvciBzdGF0dXM6ICR7cmVzcG9uc2Uuc3RhdHVzfWApO1xuXG4gICAgdGhpcy5uYW1lID0gJ0hUVFBFcnJvcic7XG4gICAgdGhpcy5yZXNwb25zZSA9IHJlc3BvbnNlO1xuICAgIHRoaXMuc3RhdHVzID0gcmVzcG9uc2Uuc3RhdHVzO1xuICB9XG59XG4iXX0=